import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CURRENCIES = [
  { code: "USD", symbol: "$", rate: 1 },
  { code: "EUR", symbol: "€", rate: 0.92 },
  { code: "GBP", symbol: "£", rate: 0.79 },
  { code: "INR", symbol: "₹", rate: 83.2 },
  { code: "AED", symbol: "AED ", rate: 3.67 },
  { code: "AUD", symbol: "A$", rate: 1.52 },
  { code: "CAD", symbol: "C$", rate: 1.36 },
  { code: "JPY", symbol: "¥", rate: 152 },
];

export const formatPrice = (usd, currency) => {
  const c = CURRENCIES.find((x) => x.code === currency) || CURRENCIES[0];
  const val = usd * c.rate;
  const fixed = c.code === "JPY" || c.code === "INR" ? val.toFixed(0) : val.toFixed(2);
  return `${c.symbol}${fixed}`;
};
